export default "__VITE_ASSET__83cb28a5__"